import React from 'react'
import { IconProps } from './interfaces/IconProps.interface'

const MapPinFill = (props: IconProps) => {
    const { color = "#000", ...rest } = props

    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <g clipPath="url(#clip0_10103_6467)">
                <path d="M12.2427 11.5761L8 15.8188L3.75734 11.5761C2.91823 10.737 2.34679 9.66789 2.11529 8.50401C1.88378 7.34013 2.0026 6.13373 2.45673 5.03738C2.91086 3.94103 3.6799 3.00396 4.66659 2.34467C5.65328 1.68539 6.81332 1.3335 8 1.3335C9.18669 1.3335 10.3467 1.68539 11.3334 2.34467C12.3201 3.00396 13.0891 3.94103 13.5433 5.03738C13.9974 6.13373 14.1162 7.34013 13.8847 8.50401C13.6532 9.66789 13.0818 10.737 12.2427 11.5761ZM8 10.0001C8.70725 10.0001 9.38552 9.71916 9.88562 9.21906C10.3857 8.71897 10.6667 8.04069 10.6667 7.33344C10.6667 6.6262 10.3857 5.94792 9.88562 5.44783C9.38552 4.94773 8.70725 4.66678 8 4.66678C7.29276 4.66678 6.61448 4.94773 6.11438 5.44783C5.61429 5.94792 5.33334 6.6262 5.33334 7.33344C5.33334 8.04069 5.61429 8.71897 6.11438 9.21906C6.61448 9.71916 7.29276 10.0001 8 10.0001ZM8 8.66678C7.64638 8.66678 7.30724 8.5263 7.05719 8.27625C6.80715 8.0262 6.66667 7.68707 6.66667 7.33344C6.66667 6.97982 6.80715 6.64068 7.05719 6.39064C7.30724 6.14059 7.64638 6.00011 8 6.00011C8.35362 6.00011 8.69276 6.14059 8.94281 6.39064C9.19286 6.64068 9.33334 6.97982 9.33334 7.33344C9.33334 7.68707 9.19286 8.0262 8.94281 8.27625C8.69276 8.5263 8.35362 8.66678 8 8.66678Z" fill={color} />
            </g>
            <defs>
                <clipPath id="clip0_10103_6467">
                    <rect width="16" height="16" fill={color} />
                </clipPath>
            </defs>
        </svg>

    )
}

export default MapPinFill